import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cpanel': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M210.3 220.2c6.6 29.1-14.5 65.3-51.7 65.3h-32l6.4-23.8c1.8-6.2 7.3-10.8 14.3-10.8h10.3c12.4 0 20.8-11.7 18.3-22.6-2.1-9.2-9.9-14.8-18.3-14.8h-19.8l-25.8 95.7c-1.9 6.2-7.4 10.7-14.2 10.7l-24.7 0.1 34.9-130.1c1.8-6.4 7.2-10.9 14.3-10.9h37c24.1 0 45.4 16.4 51 41.2zM53.8 248.2c-24.9 0-24.7 37.4 0 37.4h11.3c4.2 0 7.6 3.9 6.4 8.3l-7.1 26.1h-12.4c-33.5 0-59-31.4-50.3-65.2 7.3-27 28.3-41.1 51.2-41.1h40l-6.2 23.6c-1.9 6.5-7.4 10.9-14.3 10.9h-18.6zM301.3 213.4c18.8 0 33.3 17.6 28.5 36.8l-14 51.8c-2.8 10.6-12.2 17.8-23.4 17.8l-57.5-0.2c-42.9 0-38.5-63.8 0.7-63.8h48.4l-3.5 13.2c-1.9 6.2-7.4 10.8-14.2 10.8h-21.6c-5.3 0-5.3 7.9 0 7.9h34.9c4.6 0 5.1-3.9 5.5-5.3l8.6-31.8c0.3-1 1.9-5.3-2.1-5.3h-57.5c-9.7 0-16.6-8.9-14.2-18.5l3.5-13.4h77.9zM633.1 179c4.5 0 7.7 4 6.5 8.3l-26.5 98.2c-5.1 20.7-24.2 34.5-44.9 34.5l35.6-133.1c1.2-4.7 5.5-7.9 10.4-7.9h18.9zM396.8 213.7c34.4 0 59.3 32.3 50.3 65.4l-8.8 33.1c-1.2 4.9-5.7 7.8-10.3 7.8h-19.1c-4.5 0-7.6-4-6.4-8.3l10.6-40c3.3-11.6-5.6-23.4-18.1-23.4h-19.8l-17.2 64c-1.2 4.8-5.6 7.8-10.4 7.8h-18.9c-4.2 0-7.6-3.9-6.4-8.3l26.2-98h48.3v-0.1zM495.1 288.3h73.3l-5.7 21c-1.9 6.2-7.4 10.7-14.2 10.7h-66.7c-20 0-33.3-19-28.3-36.7l10.8-40c4.8-17.6 20.7-29.6 38.6-29.6h47.3c19 0 33.2 17.7 28.3 36.8l-3.2 12c-2.9 11-12.7 17.6-23.2 17.6h-53.4l3.5-13c1.6-6.2 7.2-10.8 14.2-10.8h21.6c2 0 3.3-1 3.9-3l0.7-2.6c0.7-2.7-1.3-5.1-3.9-5.1h-32.9c-4.1 0-6.9 2.1-7.8 6l-8 30c-0.9 3.3 1.5 6.7 5.1 6.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cpanel.js
// module id = 762
// module chunks = 0